 
import api from '../../interceptorServices';
import base_url from '../../../config';
const path = base_url+'api/management/mgmtVerifiedAccommodation';
const seriesTypeUrl = base_url+'api/admin/esSeriesType';
const subdomainTypeUrl = base_url+'api/admin/esSubdomainType';
const venueUrl = base_url+'api/admin/esVenue';
const hotelSetupUrl = base_url+'api/admin/hotelSetup';



export const getData = async (params) => {
  const whereParam = params;
  const response = await api.post(path, whereParam);
  return response.data.data;
};

export const addData = async (data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const updateData = async (data) => {
  const response = await api.put(path, data);
  return response.data;
};

export const deleteData = async (data) => {
  const response = await api.delete(path, {
    data: { id: data.id },
  });
  return response.data;
};

export const getseries = async () => {
  const response = await api.get(seriesTypeUrl);
  return response.data.data;
};

export const getsubdomain = async () => {
  const response = await api.get(subdomainTypeUrl);
  return response.data.data;
};

export const getvenue = async () => {
  const response = await api.get(venueUrl);
  return response.data.data;
};

export const gethotelSetup = async () => {
  const response = await api.get(hotelSetupUrl);
  return response.data.data;
};


